import { ar } from './ar.js';
import { en } from './en.js';
export const locales = ['ar', 'en'];
export const catalogs = { ar, en };
export function dir(locale) {
    return locale === 'ar' ? 'rtl' : 'ltr';
}
/** Minimal interpolation: {{name}} → vars.name. Framework-free so it works on node-api (print templates) too. */
export function t(locale, key, vars) {
    const raw = key
        .split('.')
        .reduce((o, k) => o?.[k], catalogs[locale]);
    const s = typeof raw === 'string' ? raw : key;
    return vars ? s.replace(/\{\{(\w+)\}\}/g, (_, n) => String(vars[n] ?? `{{${n}}}`)) : s;
}
/** True when the catalog has a string at this (runtime-built) key. */
export function has(locale, key) {
    const raw = key
        .split('.')
        .reduce((o, k) => o?.[k], catalogs[locale]);
    return typeof raw === 'string';
}
/** Flatten a catalog to key → string (used by the missing-keys test and by UI frameworks). */
export function flatten(obj, prefix = '') {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
        const key = prefix ? `${prefix}.${k}` : k;
        if (typeof v === 'string')
            out[key] = v;
        else if (v && typeof v === 'object')
            Object.assign(out, flatten(v, key));
    }
    return out;
}
//# sourceMappingURL=core.js.map